import styled from 'styled-components';

export const SubHeader = styled.p`
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
`
